module.exports = __webpack_public_path__ + "img/03.2c765cb2.png";